import { gql } from 'graphql-request'
import { clearCookies, clearSellerData } from '@/resources/utils'
import { client } from '@/proxy/client'
import { clearDatadogUser } from '@/monitoring/datadog'
import { logoutSupportChat } from '@/components/business/SupportChat/supportChatController'

const LOGOUT_MUTATION = gql`
  mutation sellerLogout {
    logout
  }
`

export const doLogout = async (redirect = true) => {
  try {
    await client.request(LOGOUT_MUTATION)
  } catch (ex) {
    console.warn(ex)
  } finally {
    logoutSupportChat()
    clearCookies()
    clearSellerData()
    clearDatadogUser()
    if (redirect) window.location.replace(`/login?_r=${Date.now()}`)
  }
}
